var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{style:({background: 'lightGrey'})},[_c('v-app-bar',{attrs:{"app":"","dense":"","hide-on-scroll":"","color":"primary","dark":""}},[_c('span',{staticClass:"mr-2"},[_vm._v("Sign Up Clipboard")]),_c('v-spacer')],1),_c('v-main',[_c('router-view',{staticClass:"mb-2 mt-2",style:({background: 'white'})})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }